var documentWrapper = {
   getDocument: function() {
      return window.document;
   }
};

export default documentWrapper;
